// extracted by mini-css-extract-plugin
export default {"Paper":"styles_Paper__PDpF5","container":"styles_container__4OFbO","error":"styles_error__vyww+","no_archived_patients":"styles_no_archived_patients__4NQS1"};